import { FUNNEL_LAYOUT_COLS } from './styles';

export const FUNNEL_CONTAINER_GRID_OPTIONS = {
  size: {
    xs: 4 / FUNNEL_LAYOUT_COLS.xs,
    sm: 4 / FUNNEL_LAYOUT_COLS.sm,
    md: 6 / FUNNEL_LAYOUT_COLS.md,
    lg: 6 / FUNNEL_LAYOUT_COLS.lg,
    xl: 6 / FUNNEL_LAYOUT_COLS.xl,
  },
  offset: {
    xs: 0,
    sm: 1 / FUNNEL_LAYOUT_COLS.sm,
    md: 1 / FUNNEL_LAYOUT_COLS.md,
    lg: 2 / FUNNEL_LAYOUT_COLS.lg,
    xl: 3 / FUNNEL_LAYOUT_COLS.xl,
  },
};

export enum BUTTON_STATUS {
  PRISTINE = 'PRISTINE',
  DIRTY = 'DIRTY',
  SAVING = 'SAVING',
  SAVING_SUCCESSFUL = 'SAVING_SUCCESSFUL',
  SAVING_UNSUCCESSFUL = 'SAVING_UNSUCCESSFUL',
  APPLICATION_LOCKED = 'APPLICATION_LOCKED',
}

export const BUTTON_STATUS_TEXTS = {
  PRISTINE: 'No changes to save',
  DIRTY: 'You’ve made changes',
  SAVING: 'Saving...',
  SAVING_SUCCESSFUL: 'Your changes have been saved',
  SAVING_UNSUCCESSFUL: 'Save failed',
  APPLICATION_LOCKED: 'Application is locked',
};

export enum LAYOUT_TYPE {
  CUSTOMER_VIEW = 'CUSTOMER_VIEW',
  CUSTOMER_VIEW_FUNNEL_ONE_TWO = 'CUSTOMER_VIEW_FUNNEL_ONE_TWO',
  TEAM_VIEW_FUNNEL_ONE = 'TEAM_VIEW_FUNNEL_ONE',
}
